import type { FC, PropsWithChildren } from 'react'
import type { ModalProps } from 'antd/es/modal'

import { SC_Modal } from './styled'

export type T_ModalProps = ModalProps

export const Modal: FC<PropsWithChildren<T_ModalProps>> = (props) => {
  const {
    children,
    ...restProps
  } = props

  return (
    <SC_Modal {...restProps}>
      {children}
    </SC_Modal>
  )
}
